import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useFeatureFlags from 'shared/hooks/useFeatureFlags';
import useCookieConsent from 'shared/hooks/useCookieConsent';
import FeedbackWidget from 'shared/components/FeedbackWidget';
import runOnMount from 'userportal/external/runOnMount';
import apiClient from 'userportal/lib/ApiClient';
import { selectors, actions } from 'userportal/ducks/auth';
import styles from './Layout.module.scss';

const Layout = ({ children }) => {
  const { onClickHandler, featureFlagsComponent } = useFeatureFlags();
  const language = useSelector(selectors.getLanguage);
  const user = useSelector(selectors.getUser);
  const dispatch = useDispatch();

  const onChangeLanguage = lang => dispatch(actions.setLanguage(lang));

  const modalComponent = useCookieConsent({
    apiClient,
    language,
    onChangeLanguage,
    runOnMount
  });

  return (
    <div className={styles.layout} onDoubleClick={onClickHandler}>
      {featureFlagsComponent}
      {children}
      {modalComponent}
      <FeedbackWidget apiClient={apiClient} userEmail={(user && user.email) || null} />
    </div>
  );
};

export default Layout;
